import { AppointRequest, Actions } from '@/types/requests';
import { Config } from '@/types/config';
import { Step } from '@/types/step';
import { getQuestionToSend } from '@/utils/step';

export function createDataFromStep (action: Actions, step: Step, appConfig: Config) {
    return new AppointRequest({
        formAction: step.formAction,
        formMethod: step.formMethod,
        action,
        stepXhrTimeout: step.questions.find(question => question.settings?.stepXhrTimeout)?.settings?.stepXhrTimeout,
        form: step.historyData ? false : step.form,
        stateId: step.stateId,
        answers: step.questions
            .filter(question => question.field)
            .map(question => ({
                formId: question.formId,
                id: question.id,
                value: getQuestionToSend(question),
            })),
    }, appConfig);
}
